// extracted by mini-css-extract-plugin
export var autoExpand = "_2p-8";
export var container = "_2p-7";
export var containerWidth = "_2p-5";
export var disabled = "_2p-2";
export var error = "_2p-3";
export var fullWidth = "_2p-6";
export var inputWrapper = "_2p-0";
export var small = "_2p-1";
export var textarea = "_2p-4";